import useMenuBack from '../../hooks/useMenuBack'
import { ArrowLeft } from 'lucide-react'
import LegalMarkdown, { useLegalContent, LegalLoadFailed } from '../../components/LegalMarkdown'
import { OrellaSpinner } from '../../components/OrellaLoader' // s123: the app's one spinner

/**
 * PrivacyPolicyScreen v242.6.0
 *
 * Renders admin-managed Privacy Policy (markdown stored in app_config via the admin panel,
 * served by GET /api/v1/legal-content). ★ 4.39 (P3): the database text is the ONE source; the
 * bundled FallbackPrivacy is gone. When the text cannot be loaded, <LegalLoadFailed> says so,
 * offers "Try again" and links the published page.
 * ★★ PROD-763 (Dr. Rami list-2 S11, R31 amended): useLegalContent('privacy') falls back to the ONE
 * bundled copy (utils/bundledPrivacy.js) when the database text cannot be loaded, so `content` is
 * that copy then; <LegalLoadFailed> is shown only if no text exists at all.
 */

const BLUE = '#46A8F9'

export default function PrivacyPolicyScreen() {
  const goBack = useMenuBack()
  const { content, loading, reload } = useLegalContent('privacy')

  return (
    <div className="min-h-full bg-white flex flex-col">
      {/* Navy Header */}
      <div
        className="flex-shrink-0 flex items-center gap-2.5"
        style={{
          padding: '14px 16px',
          paddingTop: 'calc(14px + env(safe-area-inset-top, 0px))',
          background: 'linear-gradient(135deg, #15354F, #0F2438)',
        }}
      >
        <button
          onClick={() => goBack()}
          className="p-0"
          style={{ background: 'none', border: 'none' }}
        >
          <ArrowLeft size={18} color="rgba(255,255,255,0.6)" strokeWidth={2.5} />
        </button>
        <span className="flex-1" style={{ fontSize: 16, fontWeight: 700, color: 'white' }}>
          Privacy Policy
        </span>
        <span style={{
          fontSize: 9, fontWeight: 700, padding: '3px 8px', borderRadius: 999,
          background: `${BLUE}33`, color: BLUE,
        }}>
          HIPAA
        </span>
      </div>

      {/* Content */}
      <div className="flex-1 px-4 pb-8 overflow-auto" style={{ paddingTop: 14 }}>
        {loading ? (
          <div className="flex items-center justify-center" style={{ paddingTop: 48 }}>
            <OrellaSpinner size={28} />
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </div>
        ) : content ? (
          <LegalMarkdown text={content} hideTitle />
        ) : (
          <LegalLoadFailed type="privacy" onRetry={reload} />
        )}
      </div>
    </div>
  )
}
